export default "__VITE_ASSET__B8Jsxcx6__"